"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FoodOutOfStock = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17.9809676,10 L16.5990685,10 C15.2609297,8.75882545 13.4690815,8 11.5,8 C7.35786438,8 4,11.3578644 4,15.5 L4,18 L14,18 L14,19 L2,19 L2,18 L3,18 L3,15.5 C3,10.973427 6.53831026,7.27327069 11,7.01446179 L11,6 L9,6 L9,5 L14,5 L14,6 L12,6 L12,7.01446179 C14.3942525,7.15334501 16.5226031,8.28321917 17.9809676,10 L17.9809676,10 Z M19.4968876,14.7914631 L22.1402218,12.1464466 C22.3354839,11.9511845 22.6520664,11.9511845 22.8473286,12.1464466 C23.0425907,12.3417088 23.0425907,12.6582912 22.8473286,12.8535534 L20.2037695,15.4987949 L22.8473286,18.1440365 C23.0425907,18.3392986 23.0425907,18.6558811 22.8473286,18.8511433 C22.6520664,19.0464054 22.3354839,19.0464054 22.1402218,18.8511433 L19.4968876,16.2061267 L16.8535534,18.8511433 C16.6582912,19.0464054 16.3417088,19.0464054 16.1464466,18.8511433 C15.9511845,18.6558811 15.9511845,18.3392986 16.1464466,18.1440365 L18.7900057,15.4987949 L16.1464466,12.8535534 C15.9511845,12.6582912 15.9511845,12.3417088 16.1464466,12.1464466 C16.3417088,11.9511845 16.6582912,11.9511845 16.8535534,12.1464466 L19.4968876,14.7914631 Z" })));
};
FoodOutOfStock.displayName = 'FoodOutOfStock';
exports.default = FoodOutOfStock;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FoodOutOfStock.js.map